const trackHubspot = (email: string): void => {
  const hsq = (window._hsq = window._hsq || []);
  hsq.push([
    'identify',
    {
      email,
    },
  ]);
  hsq.push(['trackPageView']);
};

export default trackHubspot;
